export function getObjectValues(obj: object): any[] {
    return Object.values(obj);
}

export function getObjectKeys(obj: object): any[] {
    return Object.keys(obj);
}

export function flattenObject(obj, flattenArray = true, separator = '.', parent = null, res = {}) {
    for (const key of Object.keys(obj)) {
        const propName = parent ? parent + separator + key : key;
        if (isObject(obj[key] || (isArray(obj[key]) && flattenArray))) {
            flattenObject(obj[key], flattenArray, separator, propName, res);
        } else {
            res[propName] = obj[key];
        }
    }
    return res;
}

export function cloneObject(obj: object): any {
    return Object.assign({}, obj);
}

export function isArray(v: any): boolean {
    return v && Array.isArray(v);
}

export function isObject(v: any): boolean {
    return v && typeof v === 'object' && !isArray(v);
}
